import axiosInstance from "../utils/axiosInstance";

export interface BrandExclusiveDeal {
  id: string;
  title: string;
  highlight: string;
  subtitle: string;
  redirectUrl: string;
  categoryType: "series" | "cruise";
  durationStart: string | null;
  durationEnd: string | null;
}

interface BrandExclusiveDealPayload {
  id: string;
  attributes: {
    title: string;
    highlight: string;
    subtitle: string;
    redirect_url: string;
    category_type: "series" | "cruise";
    duration_start: string | null;
    duration_end: string | null;
  };
}

function parseDate(value: string | null): number | null {
  if (!value) return null;

  const time = new Date(value).getTime();
  return Number.isNaN(time) ? null : time;
}

function isCurrentlyVisible(deal: BrandExclusiveDeal): boolean {
  const now = Date.now();
  const durationStart = parseDate(deal.durationStart);
  const durationEnd = parseDate(deal.durationEnd);

  return (durationStart == null || durationStart <= now) && (durationEnd == null || durationEnd >= now);
}

function normalizeRinggitLabel(value: string): string {
  return value?.replace(/\bMYR\b/g, "RM") || value;
}

class BrandExclusiveDealsApi {
  getDeals(categoryType: "series" | "cruise"): Promise<BrandExclusiveDeal[]> {
    return axiosInstance.get("/b2c2b/api/v1/brand_exclusive_deals", {
      params: { category_type: categoryType }
    }).then(response => {
      const deals = response.data.data.map((deal: BrandExclusiveDealPayload) => ({
        id: deal.id,
        title: normalizeRinggitLabel(deal.attributes.title),
        highlight: normalizeRinggitLabel(deal.attributes.highlight),
        subtitle: normalizeRinggitLabel(deal.attributes.subtitle),
        redirectUrl: deal.attributes.redirect_url,
        categoryType: deal.attributes.category_type,
        durationStart: deal.attributes.duration_start,
        durationEnd: deal.attributes.duration_end
      }));

      return deals.filter(isCurrentlyVisible);
    });
  }
}

export default new BrandExclusiveDealsApi();
